module.exports = "../../app/cells/components/new_button_share_cell.rb";